import { ReactNode } from "react";
import Badge, { BadgeVariant } from "./Badge";

export type ReportSummaryStatus = "FULFILLED" | "PENDING";

interface ReportSummaryStatusBadgeProps {
  status: ReportSummaryStatus | string;
  children: ReactNode;
  className?: string;
}

export default function ReportSummaryStatusBadge({
  status,
  children,
  className = "",
}: ReportSummaryStatusBadgeProps) {
  const getVariant = (status: string): BadgeVariant => {
    switch (status) {
      case "FULFILLED":
        return "success";
      case "PENDING":
        return "error";
      default:
        return "neutral";
    }
  };

  return (
    <Badge variant={getVariant(status)} className={className}>
      {children}
    </Badge>
  );
}
